import { render } from "./accessView.vue?vue&type=template&id=5c1eb124"
import script from "./accessView.vue?vue&type=script&lang=js"
export * from "./accessView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__